import { Component } from 'react';
import ContentLoader from 'react-content-loader';

class Loading extends Component {
    render() {
        const { singleLoader } = this.props;

        return (
            <ContentLoader
                data-cy="loader"
                height={singleLoader && 36}
                speed={2}
                style={{ marginLeft: '3em' }}
                viewBox="0 0 400 160"
                backgroundColor="#f3f3f3"
                foregroundColor="#6e6d6e"
            >
                <circle cx="10" cy="20" r="8" />
                <rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
                <circle cx="10" cy="50" r="8" />
                <rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
                <circle cx="10" cy="80" r="8" />
                <rect x="25" y="75" rx="5" ry="5" width="220" height="10" />
                <circle cx="10" cy="110" r="8" />
                <rect x="25" y="105" rx="5" ry="5" width="220" height="10" />
            </ContentLoader>
        );
    }
}

export default Loading;
